import { useContext } from 'react'
import { CommunityContext } from 'contexts'

// Provides the current community context
function useCommunity() {
  return useContext(CommunityContext)
}

export default useCommunity
